<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Jobs</h2>
    <div class="dialog-actions-wrap">
      <span class="summary-chip">Total: {{ jobs.length }}</span>
      <button mat-raised-button color="primary" class="btn-round" (click)="jobModalManager()">
        <mat-icon>add</mat-icon>
        Nuevo job
      </button>
    </div>
  </div>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="jobs"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay jobs programados.'"
      [rowClickable]="true"
      (rowClick)="jobModalManager($event.row)">
      <ng-container matColumnDef="jobName">
        <th mat-header-cell *matHeaderCellDef>Job</th>
        <td mat-cell *matCellDef="let job">{{ job.jobName }}</td>
      </ng-container>

      <ng-container matColumnDef="scheduleTime">
        <th mat-header-cell *matHeaderCellDef>Schedule Time</th>
        <td mat-cell *matCellDef="let job">{{ job.scheduleTime | date: appService.FORMAT_DATE_SEG }}</td>
      </ng-container>

      <ng-container matColumnDef="lastFiredTime">
        <th mat-header-cell *matHeaderCellDef>Last Fired</th>
        <td mat-cell *matCellDef="let job">{{ job.lastFiredTime | date: appService.FORMAT_DATE_SEG }}</td>
      </ng-container>

      <ng-container matColumnDef="groupName">
        <th mat-header-cell *matHeaderCellDef>Group</th>
        <td mat-cell *matCellDef="let job">{{ job.groupName }}</td>
      </ng-container>

      <ng-container matColumnDef="jobStatus">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let job">{{ job.jobStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let job">{{ job.result }}</td>
      </ng-container>

      <ng-container matColumnDef="nextFireTime">
        <th mat-header-cell *matHeaderCellDef>Next Fire</th>
        <td mat-cell *matCellDef="let job">{{ job.nextFireTime | date: appService.FORMAT_DATE_SEG }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
